const neutralRange = {
  LOWER_BOUND: -0.3,
  UPPER_BOUND: 0.3,
} as const

const state = {
  NEGATIVE: 'SENTIMENT_NEGATIVE',
  NEUTRAL: 'SENTIMENT_NEUTRAL',
  POSITIVE: 'SENTIMENT_POSITIVE',
  UNSCORED: 'SENTIMENT_UNSCORED',
} as const

type StateString = typeof state[keyof typeof state]

const translationKey = {
  [state.NEGATIVE]: 'negative',
  [state.NEUTRAL]: 'neutral',
  [state.POSITIVE]: 'positive',
} as const

function getStateFromScore(score: number): StateString {
  if (score < neutralRange.LOWER_BOUND) {
    return state.NEGATIVE
  } else if (score > neutralRange.UPPER_BOUND) {
    return state.POSITIVE
  } else if (score === null) {
    return state.UNSCORED
  } else {
    return state.NEUTRAL
  }
}

export { neutralRange, state, translationKey, getStateFromScore }
export default { neutralRange, state, translationKey, getStateFromScore }
